export const isNumber = (value: string | undefined | null) => {
  if (value === undefined || value === null) {
    return false;
  }
  const n = Number.parseFloat(value);
  return typeof n === 'number' && isFinite(n);
};

export const getValueOrDefault = (
  value: string | undefined | null,
  defaultValue: number,
) => {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (Number(value)) {
    return value;
  }
  return defaultValue;
};

export const getValue = (
  value1: string | null | undefined,
  value2: string | null | undefined,
  defaultValue: number,
) => {
  return value1 !== undefined
    ? getValueOrDefault(value1, defaultValue)
    : getValueOrDefault(value2, defaultValue);
};
